import { render, staticRenderFns } from "./NeedsUpdates.vue?vue&type=template&id=52b0ec59&scoped=true&"
import script from "./NeedsUpdates.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedsUpdates.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b0ec59",
  null
  
)

export default component.exports